///include /assets/js/app/p/checkout.js
class CheckoutBalance extends CheckoutDriver {
    get supportsSelection() {
        return false
    }
}

CheckoutDriver.byName.balance = CheckoutBalance